import { render, staticRenderFns } from "./ContainerNew.vue?vue&type=template&id=f0023052&scoped=true"
import script from "./ContainerNew.vue?vue&type=script&lang=js"
export * from "./ContainerNew.vue?vue&type=script&lang=js"
import style0 from "./ContainerNew.vue?vue&type=style&index=0&id=f0023052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0023052",
  null
  
)

export default component.exports